import styled from "styled-components";
export const Styles = styled.div`
  .course {
    position: relative;
    background: #fff;
    padding: 5px 20px;
    width: 290px;
    border-radius: 20px;
    box-shadow: -5px 0px 15px rgba(0, 0, 0, 0.1);
    margin-bottom:40px;
    cursor: pointer;
  }
  .course .floating-btn {
    position: absolute;
    top: 20%;
    left: -15%;
    transform: rotate(-90deg);
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: bold;
    color: #fff;
    width: 90px;
    padding: 8px;
    border-radius: 7px;
    background: var(--dark-purple);
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .course .floating-btn.recorded {
    background: var(--dark-purple);
  }
  .course .floating-btn.Live {
    background: var(--blue);
  }
  .course .course-img {
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    width: 250px;
    
    height: 168px;
    /* aspect-ratio: 250/168; */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .course .course-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* max-width: 100%;
    max-height: 100%; */
  }
  .course .course-content .course-price {
    color: var(--dark-color);
    font-size: 18px;
    display:flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .course .course-content .course-name {
    font-size: 12px;
    color: var(--dark-purple);
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    height: 17px;
    text-align: start;
  }
  .course .course-content .course-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 10px;
  }
  .course-trainer{
    font-size: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    text-align: start;
    height: 15px;
    font-weight: bold;
  }
  .course .course-content .course-decription {
    font-size: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    text-align: start;
    height: 45px;
  }
  .course .course-content .course-info .course-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .course .course-content .course-info .course-buttons span {
    width: 40px;
    height: 40px;
    font-size: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    color: #84829a;
    cursor: pointer;
  }
  .course .course-content .course-info .course-buttons span:hover {
    color: var(--dark-purple);
  }
  .course .course-content .course-statistics {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 8px;
  }
  .course .course-content .course-statistics .student,
  .course .course-content .course-statistics .sessions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .course .course-content .course-details {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .course .course-content .course-details .btn-primary {
    font-size: 12px;
    padding: 5px 40px;
  }
  .course .course-content .course-details .rates {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: var(--dark-color);
  }
  .course .course-content .course-details .rates .stars {
    color: var(--dark-purple);
    direction: ltr;
    font-size: 8px;
  }
`;
